import escapeRegExp from 'lodash/escapeRegExp';

/**
 * Return tail end of the string matching trigger upto the position.
 */
export default function getSearchTextAt(blockText, position, triggers) {
  const str = blockText.substr(0, position);

  const triggerPattern = `[${triggers.map((trigger) => escapeRegExp(trigger)).join('')}]`;

  //fix for whitespace
  const TRIGGER_REGEX = new RegExp(`(${triggerPattern})`, 'g');

  const matches = str.matchAll(TRIGGER_REGEX);

  let triggerStartIndex = 0;
  let valueStartIndex = 0;

  for (const match of matches) {
    const spaceLen = 0; //match[1].length;
    const matchLen = match[1].length;

    triggerStartIndex = (match.index || 0) + spaceLen;
    valueStartIndex = triggerStartIndex + matchLen;
  }

  const matchingString = str.slice(valueStartIndex);

  const end = str.length;

  return {
    begin: triggerStartIndex,
    end,
    matchingString,
  };
}
